export const eleData = {
  'pet1': {
    w: 197 * .6,
    h: 300 * .6
  },
  'pet2': {
    w: 200,
    h: 255
  },
  'pet3': {
    w: 300 * .6,
    h: 240 * .6
  },
  'pet4': {
    w: 300,
    h: 320
  },
  'pet5': {
    w: 229 * .6,
    h: 300 * .6
  },
  'pet6': {
    w: 270 * .6,
    h: 240 * .6
  },
  'dec1': {
    w: 352 * .6,
    h: 323 * .6
  },
  'dec2': {
    w: 275 * .8,
    h: 454 * .8
  },
  'dec3': {
    w: 352,
    h: 460
  },
  'dec4': {
    w: 700,
    h: 840
  },
  'dec5': {
    w: 330 * .8,
    h: 250 * .8
  },
  'dec6': {
    w: 330 * .6,
    h: 410 * .6
  },
  'dec7': {
    w: 380 * .8,
    h: 430 * .8
  },
  'dec8': {
    w: 80 * .6,
    h: 267 * .6
  },
  'dec9': {
    w: 350 * .6,
    h: 480 * .6
  },
  'dec10': {
    w: 285,
    h: 430
  },
  'dec11': {
    w: 281 * .8,
    h: 420 * .8
  },
  'dec12': {
    w: 155 * .6,
    h: 200 * .6
  },
  'bmm1': {
    w: 192,
    h: 520
  },
  'bmm2': {
    w: 192,
    h: 520
  },
  'bmm3': {
    w: 192,
    h: 520
  },
  'bm1': {
    w: 240,
    h: 520
  },
  'bm2': {
    w: 240,
    h: 520
  },
  'bm3': {
    w: 240,
    h: 520
  },
  'cf1': {
    w: 205,
    h: 340
  },
  'cf2': {
    w: 205,
    h: 340
  },
  'cf3': {
    w: 205,
    h: 340
  },
  'cm1': {
    w: 138,
    h: 346
  },
  'cm2': {
    w: 138,
    h: 346
  },
  'cm3': {
    w: 138,
    h: 346
  },
  'bgrHead': {
    w: 87,
    h: 110
  },
  'bHead': {
    w: 90,
    h: 110
  },
  bgrH1: {
    w: 99,
    h: 96
  },
  bgrH2: {
    w: 99,
    h: 96
  },
  bgrH3: {
    w: 99,
    h: 96
  },
  bgrH4: {
    w: 99,
    h: 96
  },
  bgrH5: {
    w: 99,
    h: 96
  },
  bgrH6: {
    w: 99,
    h: 96
  },
  bgrC1: {
    w: 272,
    h: 432
  },
  bgrC2: {
    w: 272,
    h: 432
  },
  bgrC3: {
    w: 272,
    h: 432
  },
  bgrC4: {
    w: 272,
    h: 432
  },
  bgrC5: {
    w: 272,
    h: 432
  },
  bgrC6: {
    w: 272,
    h: 432
  },
  bH1: {
    w: 197,
    h: 244
  },
  bH2: {
    w: 197,
    h: 244
  },
  bH3: {
    w: 197,
    h: 244
  },
  bH4: {
    w: 197,
    h: 244
  },
  bH5: {
    w: 197,
    h: 244
  },
  bH6: {
    w: 197,
    h: 244
  },
  bC1: {
    w: 368,
    h: 480
  },
  bC2: {
    w: 368,
    h: 480
  },
  bC3: {
    w: 368,
    h: 480
  },
  bC4: {
    w: 368,
    h: 480
  },
  bC5: {
    w: 368,
    h: 480
  },
  bC6: {
    w: 368,
    h: 480
  },
}
